import { SiteContent } from './types';

export const INITIAL_CONTENT: SiteContent = {
  siteName: 'BALUT ISLAND',
  logoUrl: '',
  dynamicStyles: {},
  navLinks: [
    { id: 'discover', label: 'Discover' },
    { id: 'activities', label: 'Experiences' },
    { id: 'register', label: 'Book Visit' },
    { id: 'gallery', label: 'Gallery' },
    { id: 'guide', label: 'Travel Guide' },
    { id: 'tips', label: 'Essentials' },
    { id: 'reviews', label: 'Guestbook' }
  ],
  hero: {
    subtitle: 'SARANGANI, DAVAO OCCIDENTAL',
    title: 'Balut Island',
    description: 'Your guide to exploring the southernmost volcanic gem of the Philippines.',
    imageUrl: 'https://images.unsplash.com/photo-1544551763-46a013bb70d5?q=80&w=2000',
    primaryCTA: 'Start Exploring',
    secondaryCTA: 'Book Your Trip',
    tertiaryCTA: 'Watch Video'
  },
  about: {
    badge: 'A HIDDEN PARADISE',
    title: 'Authentic Volcanic Beauty & Pristine Calm',
    description1: "Nestled at the edge of the Davao Gulf, Balut Island is a rare escape into nature's raw beauty. It is a place where local life moves with the tides and the landscape remains largely untouched by the modern world.",
    description2: "From hidden hot springs to the white sands of Olanivan, we invite you to experience an island that feels like a well-kept secret.",
    imageUrl: 'https://images.unsplash.com/photo-1510414842594-a61c69b5ae57?q=80&w=1000'
  },
  registration: {
    badge: 'TRAVELER ENTRY',
    title: 'Guest Registration',
    description: 'To help us preserve the natural beauty of the island and ensure your safety, we ask all visitors to register their stay before arrival.',
    buttonLabel: 'Complete Registration'
  },
  activities: {
    title: 'Island Experiences',
    subtitle: 'THINGS TO DO',
    items: [
      {
        id: '1',
        title: 'Island Hopping',
        description: 'Take a local outrigger boat to explore the nearby Olanivan and Sarangani islands.',
        image: 'https://images.unsplash.com/photo-1544551763-46a013bb70d5?q=80&w=800',
        icon: 'Compass'
      },
      {
        id: '2',
        title: 'Snorkeling',
        description: 'Dive into clear waters and discover vibrant coral gardens and rich marine life.',
        image: 'https://images.unsplash.com/photo-1582967702047-11414623bd2c?q=80&w=800',
        icon: 'Waves'
      }
    ]
  },
  gallery: {
    title: 'Photos from the Island',
    images: [
      { id: 'g1', url: 'https://images.unsplash.com/photo-1583212292454-1fe6229603b7?q=80&w=800', caption: 'Northern Coastline', category: 'nature' },
      { id: 'g2', url: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?q=80&w=800', caption: 'White Sand Beach', category: 'nature' },
      { id: 'g3', url: 'https://images.unsplash.com/photo-1544551763-46a013bb70d5?q=80&w=800', caption: 'Traditional Banca', category: 'culture' }
    ]
  },
  transport: {
    title: 'How to Get Here',
    description: 'Getting to Balut Island is an adventure in itself. Most travelers start their journey from General Santos City.',
    steps: [
      { id: 's1', title: 'Arrival at Gensan', description: 'Head to the Lion’s Beach or Puting Bato wharf in General Santos City.', icon: 'Bus' },
      { id: 's2', title: 'The Boat Trip', description: 'Take the local passenger vessel for a 5-6 hour journey across the Celebes Sea.', icon: 'Ship' },
      { id: 's3', title: 'Arrival at Mabila', description: 'Disembark at the main port in Mabila, the municipal center of Sarangani.', icon: 'MapPin' }
    ],
    proTip: 'Boat schedules can vary based on weather and sea conditions. We recommend checking locally at the port a day before your trip.'
  },
  tips: {
    title: 'Traveler Essentials',
    description: 'Everything you need to know for a smooth and respectful visit to the island.',
    bestTimeTitle: 'When to Visit',
    packingTitle: 'Packing List',
    responsibleTitle: 'Island Etiquette',
    peakMonths: 'March - May',
    offPeakMonths: 'June - February',
    packingList: [
      { id: 'p1', label: 'Cash (No ATMs on island)', icon: 'Wallet' },
      { id: 'p2', label: 'Sun Protection', icon: 'CloudSun' },
      { id: 'p3', label: 'Power Bank', icon: 'Battery' },
      { id: 'p4', label: 'Waterproof Bag', icon: 'ShoppingBag' }
    ],
    responsiblePrinciples: [
      { id: 'r1', title: 'Clean Tourism', text: 'Please take all your trash back to the mainland. Help us keep the island pristine.', icon: 'Trash2' },
      { id: 'r2', title: 'Respect Wildlife', text: 'Do not touch or disturb the coral reefs and marine life.', icon: 'Leaf' }
    ]
  },
  contact: {
    title: 'Get in Touch',
    subtitle: 'Have questions about your trip? Our local team is here to help you plan your visit.',
    phone: '+63 912 345 6789',
    email: 'info@balutisland.ph',
    location: 'Municipal Tourism Office, Mabila',
    formTitle: 'Send a Message',
    namePlaceholder: 'Full Name',
    emailPlaceholder: 'Email Address',
    phonePlaceholder: 'Phone Number',
    messagePlaceholder: 'How can we help you?',
    buttonLabel: 'Send Inquiry'
  },
  footer: {
    brandDesc: 'The southernmost volcanic paradise of the Philippines. Discover Sarangani, Davao Occidental.',
    newsletterTitle: 'Island Updates',
    newsletterDesc: 'Sign up for travel updates, weather alerts, and news from our community.',
    copyright: 'Sarangani Tourism. All rights reserved.',
    column1Header: 'Quick Links',
    column2Header: 'Support',
    socialLinks: [
      { platform: 'Facebook', url: 'https://facebook.com/' },
      { platform: 'Instagram', url: 'https://instagram.com/' },
      { platform: 'Twitter', url: 'https://twitter.com/' }
    ]
  }
};